import { useContent } from "../lib/content";

export default function News() {
  const { newsContent } = useContent();
  if (!newsContent.items || newsContent.items.length === 0) return null;

  return (
    <section id="news" className="bg-rice-50 py-20 sm:py-24">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">{newsContent.sectionTitle}</h2>
          <p className="section-subtitle">{newsContent.sectionSubtitle}</p>
        </div>

        <div className="space-y-12">
          {newsContent.items.map((item, index) => (
            <article key={index} className="card">
              <div className="flex flex-wrap items-center gap-3 text-sm text-stone-500">
                {item.date && (
                  <time dateTime={item.date}>
                    {new Date(item.date).toLocaleDateString("zh-HK", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </time>
                )}
              </div>
              <h3 className="mt-2 font-serif text-2xl font-bold text-pine-900">
                {item.title}
              </h3>
              <p className="mt-2 font-medium text-pine-700">{item.summary}</p>
              <p className="mt-4 leading-relaxed text-stone-600">{item.content}</p>

              {item.images && item.images.length > 0 && (
                <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                  {item.images.map((img, imgIndex) => (
                    <a
                      key={imgIndex}
                      href={img.src}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group block overflow-hidden rounded-xl shadow-md"
                    >
                      <img
                        src={img.src}
                        alt={img.alt}
                        className="w-full object-cover transition-transform duration-300 group-hover:scale-105"
                        loading="lazy"
                      />
                      {img.caption && (
                        <p className="bg-white px-4 py-2 text-center text-sm text-stone-600">
                          {img.caption}
                        </p>
                      )}
                    </a>
                  ))}
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
